import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SETTING_KEYS } from '@constants/settings.constant';
import { getStorage } from '@helpers/function.helper';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!getStorage(SETTING_KEYS.jwt)) {
      return next.handle(request);
    }
    return next.handle(this.addTokenHeader(request));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private addTokenHeader(request: HttpRequest<any>) {
    let headers = new HttpHeaders();
    headers = headers.set(
      'Authorization',
      `Bearer ${getStorage(SETTING_KEYS.jwt)}`
    );
    return request.clone({
      headers,
    });
  }
}

export const authInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true,
};
